// @ts-nocheck

import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';

// Actions
import ListingEngineActions from 'app/shared/flux/actions/ListingEngineActions';

// Misc / utils
import { COMMUTE_MODE_TYPES_REDUX_TO_JAVA } from 'app/shared/constants/FilterConstants';

export const useCommuteTimes = () => {
  // Redux
  const dispatch = useDispatch();

  // React
  const [commuteTimes, setCommuteTimes] = useState([]);

  const _buildCommuteApiRequest = (filter = {}, listings = [], userPoint = {}) => {
    const locationParams = {
      originLat: filter.commuteLats || userPoint.lat,
      originLon: filter.commuteLons || userPoint.lon,
      commuteTimeMode: COMMUTE_MODE_TYPES_REDUX_TO_JAVA[filter.commuteTimeMode] || 'now',
      commuteType: COMMUTE_MODE_TYPES_REDUX_TO_JAVA[filter.commuteMode] || 'DRIVING',
    };

    if (listings?.length === 0) {
      return null;
    }

    listings.forEach((listing, i) => {
      const { geo } = listing;
      const { lat, lon } = geo;

      locationParams[`lat${i}`] = lat;
      locationParams[`lon${i}`] = lon;
    });

    return locationParams;
  };

  const getCommuteTimes = ({ items = [], commuteFilter, userPoint }) => {
    if (items?.length === 0) {
      return;
    }

    const commuteTimesArray = [];

    /**
     * The commute API endpoint only accepts 10 listings at a time per request, however, we display 20 listings per page.
     * To account for this, `listingsFirstBatch` and `listingsSecondBatch` each contain 10 listings which are
     * then sent to the endpoint to fetch commute times.
     * @see: https://bitbucket.hotterpads.com/projects/HOT/repos/hotpads-web/pull-requests/6320/overview?commentId=267971
     */
    const listingsFirstBatch = items.slice(0, 10);
    const listingsSecondBatch = items.slice(10, 20);
    const locationApiParamsFirstBatch = _buildCommuteApiRequest(commuteFilter, listingsFirstBatch, userPoint);
    const locationApiParamsSecondBatch = _buildCommuteApiRequest(commuteFilter, listingsSecondBatch, userPoint);
    const formatCommuteMode = commuteFilter.commuteMode ? commuteFilter.commuteMode.toLowerCase() : 'driving';

    dispatch(ListingEngineActions.getCommuteTime(locationApiParamsFirstBatch))
      .then((res = []) => {
        res.forEach((travelTime) => {
          commuteTimesArray.push(travelTime[formatCommuteMode]);
        });

        if (locationApiParamsSecondBatch) {
          return dispatch(ListingEngineActions.getCommuteTime(locationApiParamsSecondBatch));
        } else {
          setCommuteTimes(commuteTimesArray);
          return;
        }
      })
      .then((res = []) => {
        res.forEach((travelTime) => {
          commuteTimesArray.push(travelTime[formatCommuteMode]);
        });

        setCommuteTimes(commuteTimesArray);
      })
      .catch((err) => {
        throw err;
      });
  };

  const resetCommuteTimes = () => setCommuteTimes([]);

  return [getCommuteTimes, commuteTimes, resetCommuteTimes];
};

export const usePrevious = (value) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });

  return ref.current;
};
